import { render, staticRenderFns } from "./CompletarPerfil.vue?vue&type=template&id=0f60b996&scoped=true"
import script from "./CompletarPerfil.vue?vue&type=script&lang=js"
export * from "./CompletarPerfil.vue?vue&type=script&lang=js"
import style0 from "./CompletarPerfil.vue?vue&type=style&index=0&id=0f60b996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f60b996",
  null
  
)

export default component.exports